// Keyboard offset utility for mobile virtual keyboard avoidance.
// Sets --keyboard-offset CSS variable on the target element based on
// the difference between layout viewport and visual viewport height.

export function startKeyboardOffset(element) {
  if (!window.visualViewport) return null

  const handler = () => {
    const offset = Math.max(0, window.innerHeight - window.visualViewport.height)
    element.style.setProperty("--keyboard-offset", `${offset}px`)
  }

  window.visualViewport.addEventListener("resize", handler)
  handler()

  return () => {
    window.visualViewport.removeEventListener("resize", handler)
    element.style.removeProperty("--keyboard-offset")
  }
}
